import { memo, useEffect } from 'react';
import { Platform } from 'react-native';
import {
  useSharedValue,
  useAnimatedStyle,
  withTiming,
} from 'react-native-reanimated';
import { useNavigation } from '@bonanza-social/navigation';
import { Box, PressableIcon } from '@bonanza-social/moonlight';
import { StatusChangeHeaderProps } from './StatusChangeHeader.types';

function StatusChangeHeader({
  headerShown = true,
  ...rest
}: StatusChangeHeaderProps) {
  const navigation = useNavigation();
  const animatedValue = useSharedValue(Number(headerShown));
  const animatedStyle = useAnimatedStyle(
    () => ({ opacity: animatedValue.value }),
    [],
  );

  useEffect(() => {
    animatedValue.value = withTiming(Number(headerShown), { duration: 800 });
  }, [headerShown, animatedValue]);

  return (
    <Box
      gap="space-100"
      alignItems="center"
      flexDirection="row"
      justifyContent="flex-end"
      paddingHorizontal="space-600"
      backgroundColor="backdropSecondary"
      paddingTop={Platform.select({
        ios: 'safe-area-inset-top-pure',
        web: 'safe-area-inset-top-pure',
        android: 'safe-area-inset-top',
      })}
      animatedStyle={animatedStyle}
      {...rest}
    >
      <PressableIcon
        name="info"
        width="space-600"
        height="space-600"
        gradient="accentBackground"
        onPress={() => {
          navigation.goBack();
          navigation.navigate('StatusInfo');
        }}
      />
      <PressableIcon
        name="close"
        width="space-800"
        height="space-800"
        padding="space-100"
        gradient="accentBackground"
        onPress={navigation.goBack}
      />
    </Box>
  );
}

export default memo(StatusChangeHeader);
